import React, { useEffect, useState } from "react";
import LayoutComponent from "../../components/shared/Layout";
import HeadContainer from "./HeadContainer";
import CasinoFilter from "./CasinoFilter";
import GameCard from "../../components/GameCard";
import { gamesLiveArray } from "../../constraints/constants";
import {
  popularSections,
  popularAzGames,
} from "../../constraints/popularGames";
import { useParams, useSearchParams } from "react-router-dom";
import { compact, head, isEmpty, startCase } from "lodash";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

const Casino = () => {
  const [searchParams] = useSearchParams();
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState("HOT");
  const [subCasino, setSubCasino] = useState("SEXY");
  const [casinoFilter, setCasinoFilter] = useState("catalog");
  const [popular, setPopular] = useState([]);
  const [liveArray, setLiveArray] = useState({
    gameShows: [],
    dice: [],
    traditional: [],
    roulette: [],
    baccarat: [],
    slot: [],
  });
  const [tableArray, setTabelArray] = useState([]);
  useEffect(() => {
    if (!isEmpty(searchParams.get("category"))) {
      setHeader(searchParams.get("category"));
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(header)) {
      let obj = {
        live: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "SEXY",
        table: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "KINGMAKER",
        slot: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "PP",
        fishing: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "JILI",
        egame: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "PP",
        crash: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "SMARTSOFT",
        royal: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "INOUT",
        AWC: !isEmpty(searchParams.get("type"))
          ? searchParams.get("type")
          : "BG",
      };
      if (header == "live" || header == "popular") {
        setCasinoFilter("catalog");
      } else {
        casinoFilterHandel("latest");
      }
      setSubCasinoHandel(obj[header], header);
      if (header == "popular") {
        let temp = [...popularAzGames];
        let arr = temp?.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        const result =
          arr?.length > 0 &&
          arr.reduce((acc, word) => {
            const firstLetter = word?.name[0]?.toLowerCase();
            if (!acc[firstLetter]) {
              acc[firstLetter] = [];
            }
            acc[firstLetter].push(word);
            return acc;
          }, {});
        setPopular(
          Object.keys(result).map(function (key) {
            return { name: key, array: result[key] };
          })
        );
      }
    }
  }, [header]);

  const setSubCasinoHandel = (value, type = header) => {
    setLoader(true);
    if (type !== "popular") {
      setSubCasino(value);
    }
    if (type == "HOT") {
      setTabelArray(
        gamesLiveArray?.filter(
          (res) => res?.cateogry === "HOT" && res?.type === "HOT"
        ) || []
      );
    }

    if (type == "BNG") {
      setTabelArray(
        gamesLiveArray?.filter(
          (res) => res?.cateogry === "BNG" && res?.type === "BNG"
        ) || []
      );
    }
    if (
      type == "table" ||
      type == "slot" ||
      type == "fishing" ||
      type == "egame" ||
      type == "crash" ||
      type == "royal" ||
      type == "AWC"
    ) {
      setTabelArray(
        gamesLiveArray?.filter((res) => {
          return (
            res?.cateogry == value &&
            res?.type ==
              (type == "table"
                ? "TABLE"
                : type == "slot"
                ? "SLOT"
                : type == "fishing"
                ? "FISHING"
                : type == "egame"
                ? "EGAME"
                : type == "crash"
                ? "CRASH"
                : type == "royal"
                ? "ROYAL"
                : type == "AWC"
                ? "AWC"
                : "")
          );
        }) || []
      );
    }
    if (type == "live") {
      setLiveArray({
        gameShows:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "GAME-SHOWS";
          }) || [],
        dice:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "DICE";
          }) || [],
        traditional:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "TRADITIONAL";
          }) || [],
        roulette:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "ROULETTE";
          }) || [],
        // slot:
        //   gamesLiveArray?.filter((res) => {
        //     return res?.cateogry == value && res?.type == "SLOT";
        //   }) || [],
        baccarat:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "BACCARAT";
          }) || [],
        cardGames:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "GAME-CARD";
          }) || [],
        // table:
        //   gamesLiveArray?.filter((res) => {
        //     return res?.cateogry == value && res?.type == "TABLE";
        //   }) || [],
        others:
          gamesLiveArray?.filter((res) => {
            return res?.cateogry == value && res?.type == "OTHERS";
          }) || [],
        // fishing:
        //   gamesLiveArray?.filter((res) => {
        //     return res?.cateogry == value && res?.type == "FISHING";
        //   }) || [],
        // egame:
        //   gamesLiveArray?.filter((res) => {
        //     return res?.cateogry == value && res?.type == "EGAME";
        //   }) || [],
      });
    } else if (type == "popular") {
      setLiveArray({ ...popularSections });
    }
  };

  const setheaderChange = (value) => {
    setLoader(true);
    setHeader(value);
    if (value == "live") {
      setCasinoFilter("catalog");
      setSubCasino("SEXY");
    }
    if (value == "popular") {
      setCasinoFilter("catalog");
    }
    if (value == "table") {
      setCasinoFilter("latest");
      setSubCasino("KINGMAKER");
    }
    if (value == "slot") {
      setCasinoFilter("latest");
      setSubCasino("PP");
    }
    if (value == "fishing") {
      setCasinoFilter("latest");
      setSubCasino("SPADE");
    }
    if (value == "egmae") {
      setCasinoFilter("latest");
      setSubCasino("PP");
    }
  };

  const casinoFilterHandel = (value) => {
    setLoader(true);
    setCasinoFilter(value);
    if (header !== "live" || header !== "popular") {
      if (value == "az") {
        setTabelArray(
          gamesLiveArray
            ?.filter((res) => {
              return (
                res?.cateogry == subCasino &&
                res?.type ==
                  (header == "table"
                    ? "TABLE"
                    : header == "slot"
                    ? "SLOT"
                    : header == "fishing"
                    ? "FISHING"
                    : header == "egame"
                    ? "EGAME"
                    : header == "crash"
                    ? "CRASH"
                    : header == "roya"
                    ? "ROYAL"
                    : "")
              );
            })
            ?.sort(function (a, b) {
              return a.name.localeCompare(b.name);
            })
        );
      } else if (value == "latest") {
        setSubCasinoHandel(subCasino, header);
      }
    }
  };
  useEffect(() => {
    setTimeout(function () {
      setLoader(false);
    }, 2000);
  }, [loader]);

  return (
    <div>
      <LayoutComponent visibilityType={true}>
        <HeadContainer
          header={header}
          setHeader={setheaderChange}
          subCasino={subCasino}
          setSubCasino={setSubCasinoHandel}
        />
        <div className="main-casino-wrapper">
          <CasinoFilter
            header={header}
            casinoFilter={casinoFilter}
            setCasinoFilter={casinoFilterHandel}
          />
          {loader ? (
            <SkeletonTheme baseColor="#d4e0e5">
              <div className="p-2">
                <div className="skeletion-new p-3">
                  <div className="d-flex mb-2">
                    <Skeleton
                      circle
                      height={20}
                      width={20}
                      style={{ marginRight: "10px" }}
                    />
                    <Skeleton height={17} width={120} />{" "}
                  </div>
                  <Skeleton height={17} width={"100%"} />{" "}
                  <Skeleton height={17} width={"70%"} />
                </div>
              </div>
            </SkeletonTheme>
          ) : (
            <div className="games-wrapper casino-all-games ">
              {(header == "table" ||
                header == "slot" ||
                header == "fishing" ||
                header == "crash" ||
                header == "royal" ||
                header == "egame") &&
                tableArray?.length > 0 && (
                  <div className="games-card-inner bg-white rounded-tl">
                    <div className="row" style={{ padding: "6px 0" }}>
                      {tableArray?.map((item, index) => {
                        return <GameCard key={index} res={item} />;
                      })}
                    </div>
                  </div>
                )}
              {header == "AWC" && (
                <div className="games-card-inner bg-white rounded-tl">
                  <div className="row" style={{ padding: "6px 0" }}>
                    {tableArray?.map((item, index) => {
                      return <GameCard key={index} res={item} />;
                    })}
                  </div>
                </div>
              )}
              {header == "HOT" && (
                <div className="games-card-inner bg-white rounded-tl">
                  <div className="row" style={{ padding: "6px 0" }}>
                    {tableArray?.map((item, index) => {
                      return <GameCard key={index} res={item} />;
                    })}
                  </div>
                </div>
              )}
              {header == "BNG" && (
                <div className="games-card-inner bg-white rounded-tl">
                  <div className="row" style={{ padding: "6px 0" }}>
                    {tableArray?.map((item, index) => {
                      return <GameCard key={index} res={item} />;
                    })}
                  </div>
                </div>
              )}
              {header == "live" || header == "popular" ? (
                casinoFilter == "catalog" ? (
                  <>
                    {liveArray?.gameShows?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Game Shows</h2>
                        <div className="row">
                          {liveArray?.gameShows?.map((item, index) => {
                            return <GameCard key={index} res={item} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.baccarat?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Baccarat</h2>
                        <div className="row">
                          {liveArray?.baccarat?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.roulette?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Roulette</h2>
                        <div className="row">
                          {liveArray?.roulette?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.dice?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Dice</h2>
                        <div className="row">
                          {liveArray?.dice?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.traditional?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Traditional Games</h2>
                        <div className="row">
                          {liveArray?.traditional?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.cardGames?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Card Games</h2>
                        <div className="row">
                          {liveArray?.cardGames?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.others?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Others</h2>
                        <div className="row">
                          {liveArray?.others?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.table?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Table</h2>
                        <div className="row">
                          {liveArray?.table?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.slot?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Slot</h2>
                        <div className="row">
                          {liveArray?.slot?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.fishing?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Fishing</h2>
                        <div className="row">
                          {liveArray?.fishing?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                    {liveArray?.egame?.length > 0 && (
                      <div className="games-card-inner bg-white">
                        <h2>Egame</h2>
                        <div className="row">
                          {liveArray?.egame?.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    )}
                  </>
                ) : casinoFilter == "latest" ? (
                  <div className="games-card-inner bg-white">
                    <div className="row" style={{ padding: "6px 0" }}>
                      {[
                        liveArray?.gameShows?.length > 0
                          ? liveArray?.gameShows
                          : [],
                        liveArray?.baccarat?.length > 0
                          ? liveArray?.baccarat
                          : [],
                        liveArray?.roulette?.length > 0
                          ? liveArray?.roulette
                          : [],
                        liveArray?.dice?.length > 0 ? liveArray?.dice : [],
                        liveArray?.traditional?.length > 0
                          ? liveArray?.traditional
                          : [],
                        liveArray?.cardGames?.length > 0
                          ? liveArray?.cardGames
                          : [],
                        liveArray?.table?.length > 0 ? liveArray?.table : [],
                        liveArray?.fishing?.length > 0
                          ? liveArray?.fishing
                          : [],
                        liveArray?.egame?.length > 0 ? liveArray?.egame : [],
                      ]
                        ?.flat()
                        ?.map((item, index) => {
                          return <GameCard key={index} res={item} />;
                        })}
                    </div>
                  </div>
                ) : header == "popular" && casinoFilter == "az" ? (
                  popular?.map((item) => {
                    return (
                      <div className="games-card-inner bg-white">
                        <h2>{startCase(item?.name)}</h2>
                        <div className="row" style={{ padding: "6px 0" }}>
                          {item?.array.map((res, index) => {
                            return <GameCard key={index} res={res} />;
                          })}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="games-card-inner bg-white">
                    <div className="row" style={{ padding: "6px 0" }}>
                      {compact([
                        liveArray?.gameShows?.length > 0 &&
                          liveArray?.gameShows,
                        liveArray?.baccarat?.length > 0 && liveArray?.baccarat,
                        liveArray?.roulette?.length > 0 && liveArray?.roulette,
                        liveArray?.dice?.length > 0 && liveArray?.dice,
                        liveArray?.traditional?.length > 0 &&
                          liveArray?.traditional,
                        liveArray?.cardGames?.length > 0 &&
                          liveArray?.cardGames,
                        liveArray?.table?.length > 0 && liveArray?.table,
                        liveArray?.fishing?.length && liveArray?.fishing,
                        liveArray?.egame?.length && liveArray?.egame,
                        liveArray?.slot?.length && liveArray?.slot,
                        liveArray?.others?.length && liveArray?.others,
                      ])
                        ?.flat()
                        ?.sort(function (a, b) {
                          return a?.name?.localeCompare(b.name);
                        })
                        ?.map((item, index) => {
                          return <GameCard key={index} res={item} />;
                        })}
                    </div>
                  </div>
                )
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </LayoutComponent>
    </div>
  );
};

export default Casino;
